<template lang="html">
  <v-container fluid>
    <AktivitasValidatorDialog></AktivitasValidatorDialog>
    <ValidatorDialog></ValidatorDialog>
    <lock v-if="currentDay != 6 && currentDay != 0" @status="bukaAktivitas"></lock>
    <!-- tampilan utama -->
    <template v-if="open || currentDay == 6 || currentDay == 0">
      <PanduanFiturBaru @mulai="tab = 2"></PanduanFiturBaru>
      <v-row>
        <v-col md="12" lg="8">
          <base-material-card icon="mdi-calendar">
            <calendar
              id="panduan-kalender"
              :batasTanggal="batasTanggal"
              :days="days"
              :loading="loadingAktivitas"
              @on-select-date="setSelectedDate"
              @on-change-range="setRange"
            ></calendar>
          </base-material-card>
        </v-col>

        <v-col lg="4">
          <KonfigurasiAktivitas id="panduan-verifikator"></KonfigurasiAktivitas>
          <base-material-card icon="mdi-file-chart">
            <div class="d-flex align-center mb-3">
              <div>
                <div class="overline grey--text">Tanggal dipilih</div>
                <div class="subtitle-1 font-weight-medium orange--text text--darken-2">{{selectedDate|formatTime}}</div>
              </div>
              <v-spacer></v-spacer>
              <v-chip small :color="laporanHariIni.length > 0 ? 'primary' : ''">{{laporanHariIni.length}} laporan</v-chip>
            </div>

            <v-tabs
              fixed-tabs
              v-model="tab"
              background-color="primary"
              dark
            >
              <v-tab>
                Aktivitas Utama
              </v-tab>
              <v-tab>
                Tambahan
              </v-tab>
              <v-tab id="panduan-tab-laporan">
                Laporan ({{laporanHariIni.length}})
              </v-tab>
            </v-tabs>

            <v-sheet id="panduan-laporan" max-height="550">
              <div v-if="tab == 2" class="pt-3">
                <Laporan
                  :items="laporanHariIni"
                  :loading="loadingAktivitas"
                  :canReport="showTab"
                  @edit="openDialog"
                  @delete="hapus"
                  @lapor="tab = 0"
                />
              </div>
              <div v-else-if="showTab">
                <v-text-field v-model="cari" label="Cari Aktivitas" append-icon="mdi-magnify" hide-details></v-text-field>
                <TabAktivitas :filtered='filteredData' @callDialog='openDialog'/>
              </div>
              <div v-else class="d-flex align-center flex-column">
                <v-img :src='"@/assets/mangbagja_sedih.jpg"' height="200" contain class="my-5"></v-img>
                <p class="paragraph">Anda tidak bisa input pada tanggal ini</p>
              </div>
            </v-sheet>
          </base-material-card>
        </v-col>
      </v-row>
    </template>


    <v-dialog v-model="dialog" max-width="500px">
      <v-card :loading="loadingForm">
        <v-card-title class="display-1 orange--text">Laporan Aktivitas {{selectedDate|formatTime}}</v-card-title>
        <v-card-text>

          <v-form ref="form" lazy-validation v-model="valid">
            <h1 class="display-1">{{form.nama_aktifitas}}</h1>
            <p class="paragraph mt-2">{{form.penjelasan}}</p>
            <v-select
              :items="form.kegiatan"
              item-text="nama"
              item-value="id"
              v-model="form.sasaran_kinerja_id"
              @change="showIndikator(form.sasaran_kinerja_id)"
              label="Sasaran Kinerja Pegawai"
            ></v-select>
            <h1 v-if="indikator_kuantitas != '' && indikator_kuantitas != null" class="display-1">Indikator Kuantitas</h1>
            <p v-if="showIndikator_ == true" class="paragraph mt-2">{{indikator_kuantitas}}</p>
            <h1 v-if="indikator_kualitas != '' && indikator_kualitas != null" class="display-1">Indikator Kualitas</h1>
            <p v-if="showIndikator_ == true" class="paragraph mt-2">{{indikator_kualitas}}</p>
            <h1 v-if="indikator_waktu != '' && indikator_waktu != null" class="display-1">Indikator Waktu</h1>
            <p v-if="showIndikator_ == true" class="paragraph mt-2">{{indikator_waktu}}</p>
            <v-row align="center">
              <v-col cols="3">
                <v-text-field
                label="Hasil"
                v-model="form.volume"
                :rules="[rules.required, rules.integerOnly]"
                width="10px"
                ></v-text-field>
              </v-col>
              <v-col cols="9">
                <span>x {{form.satuan_output}}</span>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col>Waktu</v-col>
              <v-col>
                <v-select
                :items="jam"
                v-model="form.jam_mulai"
                width="10px"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                :items="menit"
                v-model="form.menit_mulai"
                width="10px"
                ></v-select>
              </v-col>
              <v-col>
                sampai
              </v-col>
              <v-col>
                <v-select
                :items="jam"
                v-model="form.jam_selesai"
                width="10px"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                :items="menit"
                v-model="form.menit_selesai"
                width="10px"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="form.rumpun_id == 13">
              <h1 v-if="form.angka_kredit != '' && form.angka_kredit != null" class="display-1">Angka Kredit</h1>
              <p class="paragraph mt-2">{{form.angka_kredit}}</p>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea counter="300" label="Keterangan" @copy.prevent @paste="onPasteKeterangan" @paste.prevent @cut.prevent @drag.prevent @drop.prevent v-model="form.keterangan" hint="Isilah dengan singkat, padat, dan jelas (max 300 karakter)"></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="space-between">
                <v-btn @click="dialog=false">
                  Batal
                </v-btn>
                <v-btn :loading="loadingBtn" @click='submit' class="success" :disabled="!valid">
                  {{form.button}}
                </v-btn>
            </v-row>
          </v-form>

        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash'
import store from '@/store'
import moment from 'moment'
import PelaksanaService from '@/services/PelaksanaService'
import AktivitasService from '@/services/AktivitasService'
import TabAktivitas from './components/TabAktivitas'
import Laporan from './components/LaporanV2'
import Calendar from './components/CalendarV2'
import Lock from './components/Lock'
import KonfigurasiAktivitas from './components/KonfigurasiAktivitas'
import PanduanFiturBaru from './components/PanduanFiturBaru'
import AktivitasValidatorDialog from '@/views/skp/components/AktivitasValidatorDialog'
import ValidatorDialog from '@/views/skp/components/SkpValidatorDialog'

export default {
  components:{
    TabAktivitas,
    Laporan,
    Calendar,
    Lock,
    KonfigurasiAktivitas,
    PanduanFiturBaru,
    ValidatorDialog,
    AktivitasValidatorDialog
  },

  data: () => ({
    valid:true,
    tab: 0,
    open:false,
    batasTanggal: '',
    selectedDate: '',
    loadingBtn:false,
    loadingForm:false,
    itemsAU:[],
    itemsTmb:[],
    itemsTmbAll:[],
    cari:'',
    dialog:false,
    startDate:'',
    endDate:'',
    days:[],
    loadingAktivitas:false,
    form:{
      nama_aktifitas:'',
      penjelasan:'',
      sasaran_kinerja_id:'',
      volume:'',
      jam_mulai:7,
      menit_mulai:0,
      jam_selesai:7,
      menit_selesai:0,
      keterangan:'',
      satuan_output:'',
      angka_kredit:null,
      level:'',
      rumpun_id:null
    },
    rules:{
      required : value => !! value || 'tidak boleh kosong',
      integerOnly: v => /\d+/.test(v) || 'hanya boleh angka'
    },

    showIndikator_:false,
    indikator_kuantitas: '',
    indikator_kualitas: '',
    indikator_waktu: '',
  }),

  watch:{
    selectedDate(){
      // tampilkan laporan pada tanggal yang dipilih
      this.tab = 2
    },

    dialog(val){
      val || this.closeDialog()
    }
  },

  filters:{
    formatTime: function(value){
      moment.locale('id')
      return value ? moment(value).format('dddd, Do MMMM YYYY') : moment().format('dddd, Do MMMM YYYY');
    },
  },

  computed:{
    currentDay(){
      return moment().day()
    },

    currentDate(){
      return this.selectedDate ? this.selectedDate : moment().format('YYYY-MM-DD');
    },

    jam(){
      return _.range(24)
    },

    menit(){
      return _.range(0,60,5)
    },

    // laporan pada tanggal yang dipilih, dilengkapi nama & satuan dari master aktivitas
    laporanHariIni(){
      let day = this.days.find(x => x.tanggal == this.currentDate)
      if (!day || !day.aktivitas){
        return []
      }

      let laporan = day.aktivitas.map(x => {
        let master = (x.jenis == 'kinerja' ? this.itemsAU : this.itemsTmbAll).find(m => m.kode_aktifitas == x.kode_aktifitas) || {}
        return {
          ...x,
          nama_aktifitas: master.nama_aktifitas || x.kode_aktifitas,
          satuan_output: master.satuan_output || '',
          rumpun_id: master.rumpun_id
        }
      })

      return _.sortBy(laporan, ['jam_mulai', 'menit_mulai'])
    },

    filteredData(){
      if(this.tab == 0){
        return this.filteredAU
      }
      return this.filteredTmb
    },

    filteredAU(){
      if (this.cari.length > 2){
        const reg = new RegExp(this.cari.toLowerCase(), 'i');
        return this.itemsAU.filter(x =>reg.test(x.nama_aktifitas))
      }
      return this.itemsAU
    },

    filteredTmb(){
      if (this.cari.length > 2){
        const reg = new RegExp(this.cari.toLowerCase(), 'i');
        return this.itemsTmb.filter(x =>reg.test(x.nama_aktifitas))
      }
      return this.itemsTmb
    },

    showTab(){
      let date = this.selectedDate
      return this.compareDate(date, null) == -1 && this.compareDate(date, this.batasTanggal) == 1 || this.compareDate(date, this.batasTanggal) == 0 || this.compareDate(date, null) == 0
    }
  },

  created() {
    PelaksanaService.getTanggalInputAktivitas().then(response => {
      this.batasTanggal = response.data.hmin7
    })

    this.getAktivitasUtama()
    this.getAktivitasTambahan()
  },

  methods: {
    showIndikator(e){
      PelaksanaService.getDetailSKP(e).then(response=>{
        this.loadingBtn = false
        let data = response.data
        if (data.status == 200){
          this.showIndikator_ = true
          if(typeof data['data'][0].indikator_kuantitas != 'undefined'){
            this.indikator_kuantitas = data['data'][0].indikator_kuantitas
          }
          if(typeof data['data'][0].indikator_kualitas != 'undefined'){
            this.indikator_kualitas = data['data'][0].indikator_kualitas
          }
          if(typeof data['data'][0].indikator_waktu != 'undefined'){
            this.indikator_waktu = data['data'][0].indikator_waktu
          }
        }else{
          store.commit('snackbar/setSnack',{message:data.error, color:'error'})
        }
      }).catch(error=>{
        this.loadingBtn=false
      })
    },

    bukaAktivitas(val){
      if (val == 'open'){
        this.open = true
      } else {
        this.open = false
      }
    },

    setSelectedDate(val){
      this.selectedDate = val
    },

    setRange({from, to}){
      if (from == this.startDate && to == this.endDate){
        return
      }
      this.startDate = from
      this.endDate = to
      this.getAktivitas()
    },

    getAktivitas(){
      let from = this.startDate
      let to = this.endDate
      this.loadingAktivitas = true

      AktivitasService.getAktivitas({from: from, to: to}).then(response => {
        // abaikan response dari bulan yang sudah tidak ditampilkan
        if (from == this.startDate && to == this.endDate){
          this.days = response.data.data || []
        }
      }).catch(error => {
        store.commit('snackbar/setSnack',{message:this.getErrorMessage(error, 'Gagal mengambil data aktivitas'), color:'error'})
      }).finally(()=>{
        if (from == this.startDate && to == this.endDate){
          this.loadingAktivitas = false
        }
      })
    },

    getErrorMessage(error, fallback){
      let data = error.response ? error.response.data : null
      if (!data){
        return fallback
      }

      let errors = data.errors
      if (errors && typeof errors == 'object'){
        errors = _.flatten(Object.values(errors))[0]
      }
      return errors || data.message || fallback
    },

    submit(){
      if (this.$refs.form.validate()){
        let jenis = this.form.kategori === 'UTAMA' || this.form.jenis === 'kinerja' ? 'kinerja' : 'umum'
        this.form.id_input=this.form.id? this.form.id : -1
        this.loadingBtn = true

        AktivitasService.simpanAktivitas(this.form, jenis).then(response=>{
          let data = response.data
          if (!data.errors){
            store.commit('snackbar/setSnack',{message:data.message || 'Laporan berhasil disimpan', color:'success'})
            // tutup dialog
            this.dialog=false
            this.tab = 2
            this.getAktivitas()
          }else{
            store.commit('snackbar/setSnack',{message:this.getErrorMessage({response:response}, 'Laporan gagal disimpan'), color:'error'})
          }
        }).catch(error=>{
          store.commit('snackbar/setSnack',{message:this.getErrorMessage(error, 'Laporan gagal disimpan'), color:'error'})
        }).finally(()=>{
          this.loadingBtn = false
        })
      }else {
        this.loadingBtn = false
      }
    },

    hapus(item){
      PelaksanaService.hapusIsiAktivitas(item.id).then(response =>{
        let data = response.data
        if (data.success){
          store.commit('snackbar/setSnack',{message:data.message, color:'success'})
        }else{
          store.commit('snackbar/setSnack',{message:data.error, color:'error'})
        }

        this.getAktivitas()
      })
    },

    openDialog(item){
      this.loadingForm = true
      this.form.kode_aktivitas = item.kode_aktifitas
      this.form.tanggal = this.currentDate
      if(item.kategori == undefined){
        item.kategori = item.jenis == 'kinerja' ? 'UTAMA' : 'UMUM'
      }

      PelaksanaService.getLaporAktivitasKegiatan(item.kode_aktifitas, item.kategori).then(response=>{
        this.loadingForm = false
        let data = response.data
        this.form.penjelasan = data.data.keterangan_penjelasan
        this.form.kegiatan = data.data.kegiatan
      }).catch(error=>{
        this.loadingForm = false
      })

      this.form.kategori = item.kategori
      this.form.satuan_output = item.satuan_output
      this.form.nama_aktifitas = item.nama_aktifitas
      this.form.rumpun_id = item.rumpun_id !== undefined ? item.rumpun_id : null
      this.form.angka_kredit = item.angka_kredit !== undefined ? item.angka_kredit : null
      this.form.level = item.level !== undefined ? item.level : null

      if (!item.id){
        // buat laporan baru
        this.form.button='Simpan'
      } else {
        this.form = {...this.form, ...item}
        this.form.sasaran_kinerja_id = item.jenis == 'kinerja' ? item.sasaran_kinerja_id : item.sasaran_kinerja_tambahan_id
        // edit laporan
        this.form.button='Ubah'
      }

      this.dialog = true

    },

    closeDialog(){
      this.valid = true
      this.showIndikator_ = false
      this.indikator_kuantitas = ''
      this.indikator_kualitas = ''
      this.indikator_waktu = ''
      this.form={
        nama_aktifitas:'',
        penjelasan:'',
        sasaran_kinerja_id:'',
        volume:'',
        jam_mulai:7,
        menit_mulai:0,
        jam_selesai:7,
        menit_selesai:0,
        keterangan:'',
        satuan_output:'',
        kegiatan:[],
        angka_kredit:null,
        level:'',
        rumpun_id:null
      }
    },

    getAktivitasUtama(){
      PelaksanaService.inputAktivitasGetDataUtama().then(response=>{
        this.itemsAU = response.data.data
      })
    },

    getAktivitasTambahan(){
      PelaksanaService.inputAktivitasGetDataTambahan().then(response=>{
        this.itemsTmbAll = response.data.data || []
        this.itemsTmb = response.data.rumpun_id != 13 ? response.data.data : []
      })
    },

    compareDate(a, b) {
      let dateA = new Date(a)
      let dateB = b ? new Date(b) : new Date()
      dateA.setHours(0, 0, 0, 0)
      dateB.setHours(0, 0, 0, 0)
      if (dateA.getTime() > dateB.getTime()) {
        return 1
      } else if (dateA.getTime() < dateB.getTime()) {
        return -1
      }
      return 0
    },

    onPasteKeterangan(){
      store.commit('snackbar/setSnack',{message:'Mohon maaf tidak bisa copy-paste. :)', color:'warning', centered:true})
    }

  },
}
</script>

<style lang="scss" scoped>
</style>
